import { useEffect, useState } from "react";
import { Input } from "../commons/Form/Form";
import { formatDateTime } from "../../format";
import Button from "../commons/Button/Button";
import { Badge } from "@mui/material";
import { i18n } from "../../i18n";
import Card from "../commons/Card/Card";
import { CalendarMonth } from "@mui/icons-material";

export default function Notification({
  id,
  title,
  timestamp,
  message,
  button,
  selectedByControl,
  read,
  onAdd,
  onRemove,
  selectAllShown,
}) {
  const [selected, setSelected] = useState(selectedByControl);

  useEffect(() => {
    setSelected(selectedByControl);
  }, [selectedByControl]);

  useEffect(() => {
    if (selected) {
      onAdd(id);
    } else {
      onRemove(id);
    }
  }, [selected, id, onAdd, onRemove]);

  return (
    <div
      id={["Notification", id].join("_")}
      className={["Notification", !read && "Notification_unread"]
        .filter(Boolean)
        .join(" ")}
    >
      {selectAllShown && (
        <div className="Notification-select">
          <Input
            type="checkbox"
            value={read ? false : selected}
            onChange={setSelected}
            disabled={read}
          />
        </div>
      )}
      <div className="Notification-content-container">
        <Card className="Notification-content">
          <div className="Notification-content-header">
            <div className="Notification-content-header-title">
              <span>
                <strong>{title}</strong>
              </span>
            </div>
            <div className="Notification-content-header-timestamp">
              <CalendarMonth fontSize="small" />
              <span className="Notification-content-header-timestamp_long">
                {formatDateTime(timestamp, i18n.resolvedLanguage)}
              </span>
              <span className="Notification-content-header-timestamp_short">
                {formatDateTime(timestamp, i18n.resolvedLanguage, "short")}
              </span>
            </div>
          </div>
          <div className="Notification-content-body">
            <div className="Notitication-content-body-message">{message}</div>
            {button ? <Button {...button} variant="secondary_b" /> : null}
          </div>
        </Card>

        <Badge
          sx={{
            "& .MuiBadge-dot": {
              backgroundColor: "var(--color-error-1)",
              width: "1rem",
              height: "1rem",
              borderRadius: "50%",
            },
          }}
          overlap="circular"
          variant="dot"
          badgeContent={!read ? 1 : 0}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <div></div>{" "}
          {/*empty div to hold badge because using it on content breaks layout*/}
        </Badge>
      </div>
    </div>
  );
}
